import { Center, Image, Stack, Text } from '@mantine/core';
import NotFoundImage from '../../assets/404_not_found.svg';

export function PageNotFound() {
	return (
		<Stack align={'center'} w={'100%'} mt={30}>
			<Text fw={500} size={'l'}>
				404 Not Found!
			</Text>
			<Text size={'l'}>
				The page you are trying to access could not be found. Please contact
				MedEpos support.
			</Text>

			<Center w={'100%'}>
				<Image src={NotFoundImage} w={'30vw'} m={30} />
			</Center>
		</Stack>
	);
}
